export default function fastScoreDescription(number: number) {
  if (number >= 12) {
    return "difficultés de fonctionnement";
  }
  return "pas de difficultés de fonctionnement";
}
